import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState, useCallback } from 'react';
import axios from 'axios';
import JsBarcode from 'jsbarcode';
import HanjinWaybill from '../components/waybill/HanjinWaybill';
import KyungdongWaybill from '../components/waybill/KyungdongWaybill';
import CheonilWaybill from '../components/waybill/CheonilWaybill';
import { getCourierType } from '../utils/waybillUtils';
import { getPrintOrders } from '../api/printOrderService';
import { getOrdersByNumbers } from '../api/orderService';
import { API_BASE_URL } from '../api/axiosConfig';
function maskName(name) {
    if (!name || name.length < 2)
        return name;
    if (name.length === 2) {
        // 두 글자면 두 번째 글자만 마스킹
        return name[0] + '*';
    }
    // 세 글자 이상이면 가운데만 마스킹
    return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
}
function getBoxTypCdByFee(fee) {
    const map = {
        '2500': 'A',
        '3000': 'B',
        '4000': 'C',
        '5000': 'D',
    };
    return map[String(fee)] || 'A'; // 기본값 'A'
}
function maskPhone(phone) {
    if (!phone)
        return phone;
    // 010-1234-5678 형식 또는 01012345678 형식 모두 지원
    const digits = phone.replace(/[^0-9]/g, '');
    if (digits.length < 4)
        return phone;
    const masked = digits.slice(0, -4) + '****';
    // 하이픈 복원
    if (phone.includes('-')) {
        return masked.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-****');
    }
    return masked;
}
function maskDetailAddress(address) {
    if (!address)
        return address;
    const idx = address.lastIndexOf(' ');
    if (idx === -1)
        return address;
    return address.slice(0, idx) + ' ****';
}
const PrintWblPopup2 = () => {
    const [wblDataList, setWblDataList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [order, setOrder] = useState(null);
    // 중복 실행 방지를 위한 ref
    const isInitialized = useRef(false);
    // 바코드 참조
    const tmlBarcodeRefs = useRef([]);
    const wblNumBarcodeRefs = useRef([]);
    // 경동택배와 천일택배의 경우 트래킹 번호 조회
    const getTrackingNumber = async (orderNumber) => {
        var _a;
        try {
            const response = await fetch(`${API_BASE_URL}/api/orders/order/${orderNumber}`);
            if (response.ok) {
                const data = await response.json();
                return ((_a = data.data) === null || _a === void 0 ? void 0 : _a.tracking_number) || null;
            }
        }
        catch (error) {
            console.error('트래킹 번호 조회 오류:', error);
        }
        return null;
    };
    const getTrackingNumber2 = async (orderNumber) => {
        var _a;
        try {
            const response = await fetch(`${API_BASE_URL}/api/orders/get/orderseq/${orderNumber}`);
            if (response.ok) {
                const data = await response.json();
                return ((_a = data.data) === null || _a === void 0 ? void 0 : _a.tracking_no) || null;
            }
        }
        catch (error) {
            console.error('트래킹 번호 조회 오류:', error);
        }
        return null;
    };
    // 경동택배 API 호출 및 송장 데이터 생성
    const createKyungdongWblData = async (orderItem) => {
        try {
            console.log('경동택배 출력 정보 조회 시작:', orderItem.orderNumber);
            // 먼저 tracking_number 조회
            const trackingNumber = await getTrackingNumber2(orderItem.orderNumber);
            if (!trackingNumber) {
                console.error('경동택배 트래킹 번호를 찾을 수 없음:', orderItem.orderNumber);
                return null;
            }
            // 경동택배 출력 정보 조회 API 호출
            const response = await axios.post(`${API_BASE_URL}/api/proxy/print-wbl-kyungdong`, {
                prodCodes: [trackingNumber] // 트래킹 번호로 조회
            });
            if (response.data.success && response.data.data.data.list.length > 0) {
                const kyungdongData = response.data.data.data.list[0];
                // 경동택배 API 응답을 WaybillData 구조로 변환
                return {
                    orderInfo: {
                        order_number: orderItem.orderNumber,
                        recipient_name: kyungdongData.receiver.name,
                        address: kyungdongData.receiver.address,
                        zip_code: kyungdongData.receiver.zipCode,
                        mobile_phone: kyungdongData.receiver.telNo,
                        order_date: kyungdongData.product.sendDay,
                        quantity: kyungdongData.product.count,
                        boxqty: 1,
                        ship_comp: '경동'
                    },
                    orderNumber: orderItem.orderNumber,
                    productInfo: {
                        product_name: kyungdongData.product.name,
                        product_code: orderItem.productCode,
                        description: kyungdongData.product.memo1 || '',
                        courier_fee: 0,
                        ship_comp: '경동'
                    },
                    wbl_num: kyungdongData.product.code,
                    quantityIndex: orderItem.quantityIndex,
                    boxIndex: orderItem.boxIndex,
                    productCode: kyungdongData.product.product_code,
                    // 경동택배 전용 필드들
                    kyungdong_data: {
                        sendDay: kyungdongData.product.sendDay,
                        sendTime: kyungdongData.product.sendTime,
                        corpType: kyungdongData.product.corpType,
                        pay: kyungdongData.product.pay,
                        wrap: kyungdongData.product.wrap,
                        memo1: kyungdongData.product.memo1,
                        memo2: kyungdongData.product.memo2,
                        departureNosun: kyungdongData.product.departureNosun,
                        arrivalNosun: kyungdongData.product.arrivalNosun,
                        driverForPickup: kyungdongData.product.driverForPickup,
                        driverForDelivery: kyungdongData.product.driverForDelivery,
                        delivery: kyungdongData.product.delivery,
                        departBranch: kyungdongData.departBranch,
                        arrivalBranch: kyungdongData.arrivalBranch,
                        fare: kyungdongData.fare,
                        volume: kyungdongData.volume,
                        sender: kyungdongData.sender,
                        receiver: kyungdongData.receiver,
                        corp: kyungdongData.corp,
                        code: kyungdongData.code,
                        copies: kyungdongData.copies
                    }
                };
            }
            else {
                console.error('경동택배 API 응답 오류:', response.data);
                return null;
            }
        }
        catch (error) {
            console.error('경동택배 API 호출 오류:', error);
            return null;
        }
    };
    // 천일택배 API 호출 및 송장 데이터 생성
    const createCheonilWblData = async (orderItem) => {
        var _a, _b, _c, _d;
        try {
            console.log('천일택배 출력 정보 조회 시작:', orderItem.orderNumber);
            // 천일택배 출력 정보 조회 API 호출
            const response = await axios.post(`${API_BASE_URL}/api/proxy/print-wbl-cheonil2`, {
                orderNumbers: [orderItem.orderNumber] // 주문번호로 조회
            });
            if (response.data.success && ((_a = response.data.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const wblDataList = [];
                // 모든 천일택배 데이터에 대해 WaybillData 생성
                for (let i = 0; i < response.data.data.length; i++) {
                    const cheonilData = response.data.data[i];
                    // 천일택배 API 응답을 WaybillData 구조로 변환
                    const wblData = {
                        orderInfo: {
                            order_number: orderItem.orderNumber,
                            recipient_name: cheonilData.recipient_name,
                            address: cheonilData.address,
                            zip_code: cheonilData.zip_code,
                            mobile_phone: cheonilData.mobile_phone,
                            order_date: cheonilData.order_date,
                            quantity: cheonilData.quantity,
                            boxqty: 1,
                            ship_comp: '천일'
                        },
                        orderNumber: orderItem.orderNumber,
                        productInfo: {
                            product_name: cheonilData.product_name,
                            product_code: orderItem.productCode,
                            description: cheonilData.description,
                            courier_fee: cheonilData.courier_fee,
                            ship_comp: '천일'
                        },
                        wbl_num: (_b = cheonilData.cheonil_data) === null || _b === void 0 ? void 0 : _b.intern.asitnb,
                        quantityIndex: orderItem.quantityIndex + i,
                        boxIndex: orderItem.boxIndex + i,
                        // 천일택배 전용 필드들
                        locationInfo: {
                            A: cheonilData.locationInfo.A,
                            B: cheonilData.locationInfo.B,
                            C: cheonilData.locationInfo.C,
                            locationSort: cheonilData.locationInfo.locationSort
                        },
                        productCode: cheonilData.productCode,
                        cheonil_data: {
                            route_code: cheonilData.route_code,
                            area_code: cheonilData.area_code,
                            urgent: cheonilData.urgent,
                            delivery_type: cheonilData.delivery_type,
                            special_note: cheonilData.special_note,
                            sender_info: cheonilData.sender_info,
                            interf: (_c = cheonilData.cheonil_data) === null || _c === void 0 ? void 0 : _c.interf,
                            intern: (_d = cheonilData.cheonil_data) === null || _d === void 0 ? void 0 : _d.intern,
                            receiver_info: cheonilData.receiver_info,
                            package_info: cheonilData.package_info,
                            barcode_info: cheonilData.barcode_info
                        }
                    };
                    wblDataList.push(wblData);
                }
                console.log(`천일택배 ${wblDataList.length}개의 운송장 데이터 생성 완료`);
                return wblDataList;
            }
            else {
                console.error('천일택배 API 응답 오류:', response.data);
                return [];
            }
        }
        catch (error) {
            console.error('천일택배 API 호출 오류:', error);
            return [];
        }
    };
    // 택배사별 API 호출 함수
    const createHanjinWblData = async (orderItem) => {
        var _a, _b, _c, _d, _e, _f;
        try {
            console.log('한진택배 출력 정보 조회 시작:', orderItem.orderNumber);
            const transferResponse = await axios.post(`${API_BASE_URL}/api/courier/transfer-single-to-hanjin`, {
                order_number: orderItem.orderData.order_number,
                recipient_name: orderItem.orderData.recipient_name,
                address: orderItem.orderData.address,
                zip_code: orderItem.orderData.zip_code,
                mobile_phone: orderItem.orderData.mobile_phone,
                product_name: ((_a = orderItem.productData) === null || _a === void 0 ? void 0 : _a.product_name) || orderItem.orderData.product_name,
                quantity: orderItem.orderData.quantity || 1,
                wbl_num: orderItem.orderData.tracking_number || orderItem.orderData.tracking_no || `IMSI-${orderItem.orderData.order_number}`
            });
            const transferData = transferResponse.data;
            const waybillNumber = (transferData === null || transferData === void 0 ? void 0 : transferData.wbl_num) ||
                ((_b = transferData === null || transferData === void 0 ? void 0 : transferData.data) === null || _b === void 0 ? void 0 : _b.wblNo) ||
                ((_c = transferData === null || transferData === void 0 ? void 0 : transferData.data) === null || _c === void 0 ? void 0 : _c.wbl_num) ||
                ((_e = (_d = transferData === null || transferData === void 0 ? void 0 : transferData.data) === null || _d === void 0 ? void 0 : _d.param) === null || _e === void 0 ? void 0 : _e.wblNo) ||
                orderItem.orderData.tracking_number ||
                orderItem.orderData.tracking_no;
            if (!(transferData === null || transferData === void 0 ? void 0 : transferData.success) || !waybillNumber) {
                console.error('한진택배 단건 전송 응답 오류:', transferData);
                return null;
            }
            return {
                ...transferData,
                ...transferData === null || transferData === void 0 ? void 0 : transferData.data,
                wbl_num: waybillNumber,
                orderInfo: {
                    order_number: orderItem.orderData.order_number,
                    recipient_name: orderItem.orderData.recipient_name,
                    address: orderItem.orderData.address,
                    zip_code: orderItem.orderData.zip_code,
                    mobile_phone: orderItem.orderData.mobile_phone,
                    order_date: orderItem.orderData.order_date,
                    quantity: orderItem.orderData.quantity,
                    boxqty: orderItem.orderData.box_qty || 1,
                    ship_comp: orderItem.orderData.ship_comp
                },
                orderNumber: orderItem.orderData.order_number,
                productInfo: {
                    product_name: ((_f = orderItem.productData) === null || _f === void 0 ? void 0 : _f.product_name) || orderItem.orderData.product_name,
                    product_code: orderItem.productCode,
                    description: orderItem.orderData.description || '',
                    courier_fee: orderItem.orderData.ship_comp_fee || orderItem.orderData.shipping_fee || 0,
                    ship_comp: orderItem.orderData.ship_comp
                },
                quantityIndex: orderItem.quantityIndex || 1,
                boxIndex: orderItem.boxIndex || 1,
                locationInfo: orderItem.locationInfo,
                productCode: orderItem.productCode,
                courier_type: 'hanjin',
                boxType: getBoxTypCdByFee(orderItem.orderData.ship_comp_fee || orderItem.orderData.shipping_fee || 2500)
            };
        }
        catch (error) {
            console.error('한진택배 API 호출 오류:', error);
            return null;
        }
    };
    const sendToCourier = async (wblData) => {
        var _a, _b, _c;
        const courierType = getCourierType(((_a = wblData.productInfo) === null || _a === void 0 ? void 0 : _a.ship_comp) || ((_b = wblData.orderInfo) === null || _b === void 0 ? void 0 : _b.ship_comp) || '');
        switch (courierType) {
            case 'kyungdong':
                // 경동택배의 경우 별도 처리가 필요하므로 성공 응답 반환
                console.log('경동택배는 별도 프로세스에서 처리됩니다.');
                return { success: true, message: '경동택배 처리 완료' };
            case 'cheonil':
                // 천일택배의 경우 별도 처리가 필요하므로 성공 응답 반환
                console.log('천일택배는 별도 프로세스에서 처리됩니다.');
                return { success: true, message: '천일택배 처리 완료' };
            default:
                console.warn(`알 수 없는 택배사: ${(_c = wblData.productInfo) === null || _c === void 0 ? void 0 : _c.ship_comp}, 경동택배로 처리`);
                return { success: true, message: '경동택배 처리 완료' };
        }
    };
    useEffect(() => {
        // 중복 실행 방지
        if (isInitialized.current)
            return;
        isInitialized.current = true;
        const processOrders = async () => {
            try {
                console.log('=== 송장 출력 프로세스 시작 ===');
                // tb_print_orders 테이블에서 오늘 저장된 주문번호들 조회
                let orderNumbers = [];
                try {
                    const printOrdersResult = await getPrintOrders();
                    orderNumbers = printOrdersResult.data || [];
                    console.log('데이터베이스에서 조회된 주문번호들:', orderNumbers);
                }
                catch (error) {
                    console.error('주문번호 조회 실패:', error);
                    alert('주문번호를 조회할 수 없습니다.');
                    return;
                }
                if (orderNumbers.length === 0) {
                    console.log('처리할 주문번호가 없습니다.');
                    alert('처리할 주문이 없습니다.');
                    return;
                }
                // 주문번호들로 주문 정보 조회
                let orderWithLocationList = [];
                try {
                    const ordersResult = await getOrdersByNumbers(orderNumbers);
                    const ordersData = ordersResult.data || [];
                    console.log('주문 정보 조회 결과:', ordersData);
                    // 기존 형식에 맞게 변환
                    orderWithLocationList = await Promise.all(ordersData.map(async (orderData) => {
                        let locationInfo = null;
                        let locationSort = `Z-Z-Z-${orderData.product_code || 'UNKNOWN'}`;
                        let productName = orderData.product_name; // 기본값으로 주문의 상품명 사용
                        // 상품 코드로 상품 정보 조회
                        if (orderData.product_code) {
                            try {
                                const productResponse = await axios.get(`${API_BASE_URL}/api/products/product/${orderData.product_code}`);
                                if (productResponse.data && productResponse.data.product_name) {
                                    productName = productResponse.data.product_name;
                                    console.log(`상품 ${orderData.product_code}의 이름: ${productName}`);
                                }
                                else {
                                    console.warn(`상품 ${orderData.product_code}의 정보를 찾을 수 없음, 기본값 사용: ${productName}`);
                                }
                            }
                            catch (error) {
                                console.warn(`상품 정보 조회 실패 (상품코드: ${orderData.product_code}):`, error);
                                console.log(`기본값 사용: ${productName}`);
                            }
                        }
                        // 상품 코드로 로케이션 정보 조회
                        if (orderData.product_code) {
                            try {
                                const locationResponse = await axios.post(`${API_BASE_URL}/api/locations/available`, {
                                    product_code: orderData.product_code
                                });
                                if (locationResponse.data && locationResponse.data.length > 0) {
                                    const location = locationResponse.data[0];
                                    locationInfo = {
                                        A: location.A,
                                        B: location.B,
                                        C: location.C,
                                        locationSort: `${location.A}-${location.B}-${location.C}-${orderData.product_code}`
                                    };
                                    locationSort = locationInfo.locationSort;
                                    console.log(`상품 ${orderData.product_code}의 로케이션: ${locationSort}`);
                                }
                                else {
                                    console.warn(`상품 ${orderData.product_code}의 로케이션 정보를 찾을 수 없음`);
                                    // 로케이션 정보가 없어도 상품코드는 포함
                                    locationSort = `Z-Z-Z-${orderData.product_code}`;
                                }
                            }
                            catch (error) {
                                console.warn(`로케이션 조회 실패 (상품코드: ${orderData.product_code}):`, error);
                                // 로케이션 조회 실패 시에도 상품코드는 포함
                                locationSort = `Z-Z-Z-${orderData.product_code}`;
                            }
                        }
                        return {
                            orderNumber: orderData.order_number,
                            orderSeq: orderData.id,
                            orderData: orderData,
                            productCode: orderData.product_code,
                            productData: {
                                product_name: productName,
                                product_code: orderData.product_code
                            },
                            locationInfo: locationInfo,
                            locationSort: locationSort,
                            quantityIndex: 0,
                            boxIndex: 0
                        };
                    }));
                }
                catch (error) {
                    console.error('주문 정보 조회 실패:', error);
                    alert('주문 정보를 조회할 수 없습니다.');
                    return;
                }
                if (orderWithLocationList.length === 0) {
                    alert('유효한 주문 정보를 찾을 수 없습니다.');
                    return;
                }
                console.log('처리할 주문들:', orderWithLocationList);
                setLoading(true);
                setError(null);
                // 로케이션별로 정렬
                orderWithLocationList.sort((a, b) => {
                    const aSort = a.locationSort || `Z-Z-Z-${a.productCode || 'UNKNOWN'}`;
                    const bSort = b.locationSort || `Z-Z-Z-${b.productCode || 'UNKNOWN'}`;
                    return aSort.localeCompare(bSort);
                });
                console.log('로케이션 순서대로 정렬된 주문 목록:');
                orderWithLocationList.forEach((orderItem, index) => {
                    console.log(`${index + 1}. 주문: ${orderItem.orderNumber}, 상품: ${orderItem.productCode}, 로케이션: ${orderItem.locationSort}, 택배사: ${orderItem.orderData.ship_comp}`);
                });
                // 순차적으로 택배사별 송장 생성
                const wblList = [];
                // 순차적으로 택배사별 송장 생성
                for (let index = 0; index < orderWithLocationList.length; index++) {
                    const orderItem = orderWithLocationList[index];
                    try {
                        console.log(`송장 ${index + 1} 생성 시작: ${orderItem.orderNumber}`);
                        let wblData = null;
                        // 택배사 타입 확인
                        const courierType = getCourierType(orderItem.orderData.ship_comp || '');
                        // 택배사별로 다른 송장 생성 프로세스
                        switch (courierType) {
                            case 'hanjin':
                                console.log('한진택배 송장 생성 프로세스 시작');
                                wblData = await createHanjinWblData({
                                    ...orderItem,
                                    quantityIndex: 1,
                                    boxIndex: 1
                                });
                                if (!wblData) {
                                    console.error('한진택배 송장 생성 실패');
                                    continue;
                                }
                                wblData.sequenceNumber = index + 1;
                                wblData.totalCount = orderWithLocationList.length;
                                wblData.locationInfo = orderItem.locationInfo;
                                wblData.productCode = orderItem.productCode;
                                wblData.courier_type = 'hanjin';
                                console.log(`한진택배 송장 ${wblData.wbl_num} 생성 성공`);
                                break;
                            case 'kyungdong':
                                // 경동: 경동택배 전용 API 호출
                                console.log('경동택배 송장 생성 프로세스 시작');
                                // quantity * box_qty 갯수만큼 송장 생성
                                const totalQty = orderItem.orderData.quantity * orderItem.orderData.box_qty;
                                const kyungdongWblDataList = [];
                                for (let i = 0; i < totalQty; i++) {
                                    const kyungdongOrderItem = {
                                        ...orderItem,
                                        orderNumber: `${orderItem.orderData.order_number}-${String(i + 1).padStart(2, '0')}`,
                                        quantityIndex: i + 1,
                                        boxIndex: (i % orderItem.orderData.box_qty) + 1
                                    };
                                    const kyungdongWblData = await createKyungdongWblData(kyungdongOrderItem);
                                    if (kyungdongWblData) {
                                        console.log(`경동택배 송장 ${kyungdongWblData.wbl_num} 생성 성공 (${i + 1}/${totalQty})`);
                                        // 추가 정보 설정
                                        const locationResponse = await axios.post(`${API_BASE_URL}/api/locations/available`, {
                                            product_code: kyungdongWblData.productCode
                                        });
                                        const location = locationResponse.data[0];
                                        if (location) {
                                            kyungdongWblData.locationInfo = {
                                                A: location.A,
                                                B: location.B,
                                                C: location.C,
                                                locationSort: `${location.A}-${location.B}-${location.C}-${kyungdongWblData.productCode}`
                                            };
                                        }
                                        else {
                                            kyungdongWblData.locationInfo = {
                                                A: 'Z',
                                                B: 'Z',
                                                C: 'Z',
                                                locationSort: `Z-Z-Z-${kyungdongWblData.productCode}`
                                            };
                                        }
                                        kyungdongWblData.sequenceNumber = index + 1 + i;
                                        kyungdongWblData.totalCount = orderWithLocationList.length;
                                        // kyungdongWblData.locationInfo = orderItem.locationInfo;
                                        // kyungdongWblData.productCode = orderItem.productCode;
                                        kyungdongWblData.courier_type = 'kyungdong';
                                        kyungdongWblDataList.push(kyungdongWblData);
                                    }
                                    else {
                                        console.error(`경동택배 송장 생성 실패 (${i + 1}/${totalQty})`);
                                    }
                                    // API 호출 간격 조절 (300ms 대기)
                                    if (i < totalQty - 1) {
                                        await new Promise(resolve => setTimeout(resolve, 300));
                                    }
                                }
                                if (kyungdongWblDataList.length > 0) {
                                    wblList.push(...kyungdongWblDataList);
                                    //  wblData = kyungdongWblDataList[0]; // 첫 번째 송장을 wblData로 설정
                                    console.log(`경동택배 ${kyungdongWblDataList.length}개 송장 생성 완료`);
                                }
                                else {
                                    console.error(`경동택배 송장 생성 실패`);
                                    continue; // 실패한 경우 다음 주문으로
                                }
                                break;
                            case 'cheonil':
                                // 천일: 천일택배 전용 API 호출
                                console.log('천일택배 송장 생성 프로세스 시작');
                                const cheonilWblData = await createCheonilWblData(orderItem);
                                if (cheonilWblData.length > 0) {
                                    console.log(`천일택배 ${cheonilWblData.length}개의 운송장 생성 성공`);
                                    // 추가 정보 설정
                                    cheonilWblData.forEach((wblDataItem, i) => {
                                        wblDataItem.sequenceNumber = index + 1 + i;
                                        wblDataItem.totalCount = orderWithLocationList.length;
                                        //wblDataItem.locationInfo = orderItem.locationInfo;
                                        //wblDataItem.productCode = orderItem.productCode;
                                        wblDataItem.courier_type = 'cheonil';
                                    });
                                    wblList.push(...cheonilWblData);
                                    // 천일택배는 여러 개의 운송장이 생성되므로 wblData를 첫 번째로 설정
                                    //  wblData = cheonilWblData[0];
                                }
                                else {
                                    console.error(`천일택배 송장 생성 실패`);
                                    continue; // 실패한 경우 다음 주문으로
                                }
                                break;
                            default:
                                console.warn(`알 수 없는 택배사: ${courierType}, 경동택배로 처리`);
                                // 기본값으로 경동택배 처리
                                const kyungdongOrderItem = {
                                    ...orderItem,
                                    orderNumber: orderItem.orderData.order_number,
                                    quantityIndex: 1,
                                    boxIndex: 1
                                };
                                const defaultWblData = await createKyungdongWblData(kyungdongOrderItem);
                                if (defaultWblData) {
                                    defaultWblData.sequenceNumber = index + 1;
                                    defaultWblData.totalCount = orderWithLocationList.length;
                                    defaultWblData.locationInfo = orderItem.locationInfo;
                                    defaultWblData.productCode = orderItem.productCode;
                                    defaultWblData.courier_type = 'kyungdong';
                                    wblList.push(defaultWblData);
                                    console.log(`기본 경동택배 송장 ${defaultWblData.wbl_num} 생성 성공`);
                                }
                                break;
                        }
                        if (wblData && courierType !== 'cheonil' && courierType !== 'kyungdong') {
                            wblList.push(wblData);
                        }
                        else if (courierType === 'kyungdong') {
                            // 경동택배는 이미 위에서 wblList에 추가했으므로 로그만 출력
                            console.log(`경동택배 송장들 생성 완료: ${orderItem.orderNumber}`);
                        }
                        // 각 송장 생성 간 짧은 대기 (API 부하 방지)
                        if (index < orderWithLocationList.length - 1) {
                            await new Promise(resolve => setTimeout(resolve, 500));
                        }
                    }
                    catch (error) {
                        console.error(`송장 생성 오류 (${orderItem.orderNumber}):`, error);
                    }
                }
                // 로케이션 순서대로 wblList 재정렬
                wblList.sort((a, b) => {
                    // locationInfo가 있는 경우 A-B-C 형태로 정렬
                    const getLocationSort = (wblData) => {
                        if (wblData.locationInfo && wblData.locationInfo.A && wblData.locationInfo.B && wblData.locationInfo.C) {
                            // A는 문자열로, B와 C는 숫자로 처리하여 정렬 키 생성
                            const a = String(wblData.locationInfo.A);
                            const b = String(wblData.locationInfo.B).padStart(3, '0'); // B도 숫자를 3자리로 패딩
                            const c = String(wblData.locationInfo.C).padStart(3, '0'); // 숫자를 3자리로 패딩
                            const productCode = String(wblData.productCode || '') + String(wblData.courier_type || '');
                            return { a, b, c, productCode, hasLocation: true };
                        }
                        // locationInfo가 없으면 productCode 기준으로 정렬
                        if (wblData.productCode) {
                            return { a: 'Z', b: 'Z', c: 'Z', productCode: String(wblData.productCode), hasLocation: false };
                        }
                        // 둘 다 없으면 맨 마지막
                        return { a: 'Z', b: 'Z', c: 'Z', productCode: 'UNKNOWN', hasLocation: false };
                    };
                    const aSort = getLocationSort(a);
                    const bSort = getLocationSort(b);
                    // 1차: A 정렬 (영문 먼저, 그 다음 한글)
                    const aCompare = aSort.a.localeCompare(bSort.a, 'ko', {
                        numeric: true,
                        sensitivity: 'base',
                        caseFirst: 'upper'
                    });
                    if (aCompare !== 0)
                        return aCompare;
                    // 2차: B 정렬 (숫자로 처리)
                    const bCompare = aSort.b.localeCompare(bSort.b, undefined, { numeric: true });
                    if (bCompare !== 0)
                        return bCompare;
                    // 3차: C 정렬 (숫자로 처리)
                    const cCompare = aSort.c.localeCompare(bSort.c, undefined, { numeric: true });
                    if (cCompare !== 0)
                        return cCompare;
                    // 4차: 상품코드 정렬
                    return aSort.productCode.localeCompare(bSort.productCode, 'ko', {
                        numeric: true,
                        sensitivity: 'base'
                    });
                });
                console.log('로케이션 순서대로 재정렬된 송장 목록:');
                wblList.forEach((wblData, index) => {
                    const locationSort = wblData.locationInfo ?
                        `${wblData.locationInfo.A}-${wblData.locationInfo.B}-${wblData.locationInfo.C}-${wblData.productCode}` :
                        `상품코드: ${wblData.productCode || 'UNKNOWN'}`;
                    console.log(`${index + 1}. 송장: ${wblData.wbl_num}, 로케이션: ${locationSort}, 택배사: ${wblData.courier_type}`);
                });
                if (wblList.length === 0) {
                    setError('출력할 운송장 데이터가 없습니다.');
                    setLoading(false);
                    return;
                }
                setWblDataList(wblList);
                setLoading(false);
                console.log(`총 ${wblList.length}개의 송장이 로케이션 순서대로 생성되었습니다.`);
                // 트래킹번호 업데이트
                if (wblList.length > 0) {
                    const orderTrackingMap = new Map();
                    wblList.forEach((wblData) => {
                        var _a;
                        const orderNumber = (_a = wblData.orderInfo) === null || _a === void 0 ? void 0 : _a.order_number;
                        const orderData = orderWithLocationList.find((item) => item.orderNumber === orderNumber);
                        const orderId = orderData === null || orderData === void 0 ? void 0 : orderData.orderSeq;
                        if (wblData.courier_type === 'cheonil') {
                            if (orderNumber && orderId && !orderTrackingMap.has(orderNumber)) {
                                orderTrackingMap.set(orderNumber, {
                                    order_id: orderId,
                                    tracking_no: wblData.wbl_num,
                                    orderNumber: orderNumber
                                });
                            }
                        }
                    });
                }
                // 3초 후 자동 인쇄 시작
                setTimeout(() => {
                    console.log('자동 인쇄 실행');
                    silentPrint();
                }, 3000);
            }
            catch (err) {
                console.error('주문 처리 오류:', err);
                setError('주문 정보를 불러오지 못했습니다: ' + err.message);
                setLoading(false);
            }
        };
        processOrders();
    }, []); // 빈 의존성 배열로 한 번만 실행
    // 바코드 생성 useEffect
    useEffect(() => {
        if (wblDataList.length > 0) {
            wblDataList.forEach((wblData, index) => {
                // 도착지 터미널 바코드 (CODE128)
                if (tmlBarcodeRefs.current[index] && wblData.tml_cod) {
                    JsBarcode(tmlBarcodeRefs.current[index], wblData.tml_cod, {
                        format: 'CODE128',
                        width: 1.2,
                        height: 32,
                        displayValue: false,
                        margin: 0,
                    });
                }
                // 운송장번호 바코드 (Interleaved 2 of 5)
                if (wblNumBarcodeRefs.current[index] && wblData.wbl_num) {
                    JsBarcode(wblNumBarcodeRefs.current[index], wblData.wbl_num, {
                        format: 'ITF',
                        width: 1.4,
                        height: 80,
                        displayValue: false,
                        margin: 0,
                    });
                }
            });
        }
    }, [wblDataList]);
    // 자동 인쇄를 위한 useEffect 추가
    useEffect(() => {
        // 페이지 로드 시 프린트 스타일 추가
        const style = document.createElement('style');
        style.textContent = `
      @page {
        size: 260mm 120mm;
        margin: 0;
        padding: 0;
      }
      
      @media print {
        * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        
        body {
          margin: 0 !important;
          padding: 0 !important;
          width: 260mm !important;
          height: 120mm !important;
        }
        
        .no-print {
          display: none !important;
        }
        
        .waybill-container {
          width: 260mm !important;
          height: 120mm !important;
          margin: 0 !important;
          padding: 0 !important;
          page-break-after: always;
          page-break-inside: avoid;
          break-inside: avoid;
        }
        
        .waybill-container:last-child {
          page-break-after: avoid;
          break-after: avoid;
        }
      }
      
      body {
        margin: 0;
        padding: 0;
        font-family: 'HY헤드라인M', 'Malgun Gothic', 'Arial', sans-serif;
        width: 100%;
        min-height: 100vh;
      }
      
      html, body {
        width: 100%;
        min-height: 100vh;
        overflow-x: hidden;
      }
    `;
        document.head.appendChild(style);
        // 자동 인쇄를 위한 이벤트 리스너 추가
        const handleBeforePrint = () => {
            console.log('인쇄 시작');
        };
        const handleAfterPrint = () => {
            console.log('인쇄 완료');
            // 인쇄 완료 후 창 닫기 (선택사항)
            // window.close();
        };
        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);
        return () => {
            document.head.removeChild(style);
            window.removeEventListener('beforeprint', handleBeforePrint);
            window.removeEventListener('afterprint', handleAfterPrint);
        };
    }, []);
    // 자동 인쇄 함수
    const silentPrint = useCallback(() => {
        var _a;
        try {
            // 강제 인쇄 실행
            console.log(`인쇄 시작 - 총 ${wblDataList.length}개 운송장`);
            // 새 창에서 인쇄 (더 안정적)
            const printWindow = window.open('', '_blank', 'width=800,height=600');
            if (printWindow) {
                const printContent = ((_a = document.querySelector('.print-content')) === null || _a === void 0 ? void 0 : _a.innerHTML) || '';
                printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>운송장 인쇄</title>
            <style>
              @page { 
                size: 260mm 120mm; 
                margin: 0; 
                padding: 3mm;
                -webkit-print-color-adjust: exact;
                color-adjust: exact;
              }
              
              @media print {
                * {
                  -webkit-print-color-adjust: exact !important;
                  color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
                
                body {
                  margin: 0 !important;
                  padding: 0 !important;
                  font-family: 'HY헤드라인M', 'Malgun Gothic', 'Arial', sans-serif;
                }
                
                .waybill-container {
                  width: 260mm !important;
                  height: 120mm !important;
                  margin: 0 auto!important;
                  padding: 3mm !important;
                  page-break-after: always;
                  border: 1px solid #000;
                  box-sizing: border-box;
                  display: block !important;
                  position: relative;
                }
                
                .waybill-container:last-child {
                  page-break-after: avoid;
                }
                
                .no-print {
                  display: none !important;
                }
                
                .print-content {
                  width: 100%;
                  height: auto;
                }
              }
              
              body {
                margin: 0;
                padding: 0;
                font-family: 'HY헤드라인M', 'Malgun Gothic', 'Arial', sans-serif;
                width: 100%;
                height: auto;
              }
              
              .waybill-container {
                width: 260mm;
                height: 120mm;
                margin: 0;
                padding: 0;
                page-break-after: always;
                border: 1px solid #000;
                box-sizing: border-box;
                display: block;
                position: relative;
              }
              
              .waybill-container:last-child {
                page-break-after: avoid;
              }
            </style>
            <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
          </head>
          <body>
            ${printContent}
            <script>
              // 바코드 재생성
              window.onload = function() {
                console.log('새 창에서 바코드 재생성 시작');
                
                // 모든 바코드 요소 찾기
                const tmlBarcodes = document.querySelectorAll('svg[data-barcode-type="tml"]');
                const wblBarcodes = document.querySelectorAll('svg[data-barcode-type="wbl"]');
                const eblBarcodes = document.querySelectorAll('svg[data-barcode-type="ebl"]');
                const mainBarcodes = document.querySelectorAll('svg[data-barcode-type="main"]');
                
                console.log('터미널 바코드 개수:', tmlBarcodes.length);
                console.log('운송장 바코드 개수:', wblBarcodes.length);
                
                tmlBarcodes.forEach((svg, index) => {
                  const code = svg.getAttribute('data-code');
                  if (code && window.JsBarcode) {
                    JsBarcode(svg, code, {
                      format: 'CODE128',
                      width: 1.2,
                      height: 32,
                      displayValue: false,
                      margin: 0,
                    });
                  }
                });
                
                wblBarcodes.forEach((svg, index) => {
                  const code = svg.getAttribute('data-code');
                  if (code && window.JsBarcode) {
                    JsBarcode(svg, code, {
                      format: 'ITF',
                      width: 1.8,
                      height: 80,
                      displayValue: false,
                      margin: 0,
                    });
                  }
                });

                eblBarcodes.forEach((svg, index) => {
                  const code = svg.getAttribute('data-code');
                  if (code && window.JsBarcode) {
                    JsBarcode(svg, code, {
                      format: 'ITF',
                      width: 3,
                      height: 80,
                      displayValue: false,
                      margin: 0,
                    });
                  }
                });

                mainBarcodes.forEach((svg, index) => {
                  const code = svg.getAttribute('data-code');
                  if (code && window.JsBarcode) {
                    JsBarcode(svg, code, {
                      format: 'CODE128',
                      width: 2.3,
                      height: 55,
                      displayValue: true,
                      margin: 0,
                    });
                  }
                });
                
                console.log('바코드 재생성 완료');
                
                // 바코드 생성 후 자동 인쇄
                setTimeout(() => {
                  console.log('인쇄 실행');
                  window.print();
                  setTimeout(() => {
                    console.log('창 닫기');
                    window.close();
                  }, 2000); // 인쇄 완료 대기 시간 증가
                }, 1000); // 바코드 생성 대기 시간 증가
              };
            </script>
          </body>
          </html>
        `);
                printWindow.document.close();
                printWindow.focus();
            }
            else {
                // 팝업이 차단된 경우 기본 인쇄 사용
                console.log('팝업 차단됨, 기본 인쇄 사용');
                window.print();
                // window.close(); // 기본 인쇄에서는 창을 닫지 않음
            }
        }
        catch (error) {
            console.error('자동 인쇄 오류:', error);
            // 오류 발생 시 기본 인쇄 시도
            window.print();
        }
    }, [wblDataList]);
    // 택배사별 송장 컴포넌트 렌더링
    const renderWaybillByType = (wblData, index) => {
        var _a, _b;
        const courierType = getCourierType(((_a = wblData.productInfo) === null || _a === void 0 ? void 0 : _a.ship_comp) || ((_b = wblData.orderInfo) === null || _b === void 0 ? void 0 : _b.ship_comp) || '');
        switch (courierType) {
            case 'hanjin':
                return _jsx(HanjinWaybill, { wblData: wblData, index: index }, index);
            case 'kyungdong':
                return _jsx(KyungdongWaybill, { wblData: wblData, index: index }, index);
            case 'cheonil':
                return _jsx(CheonilWaybill, { wblData: wblData, index: index }, index);
            default:
                // 기본값으로 경동택배 사용
                return _jsx(KyungdongWaybill, { wblData: wblData, index: index }, index);
        }
    };
    if (loading)
        return _jsx("div", { style: { padding: 0 }, children: "\uC6B4\uC1A1\uC7A5 \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uB294 \uC911..." });
    if (error)
        return _jsx("div", { style: { padding: 0, color: 'red' }, children: error });
    if (wblDataList.length === 0)
        return _jsx("div", { style: { padding: 0 }, children: "\uB370\uC774\uD130 \uC5C6\uC74C" });
    return (_jsx("div", { className: "print-content", children: wblDataList.map((wblData, index) => renderWaybillByType(wblData, index)) }));
};
export default PrintWblPopup2;
